/**
 * @file Analytics.
 */

/**
 * Analytics component.
 */
const vAnalytics = () => {
	const dataLayer = window.dataLayer || [];

	/**
	 * Get the clicked element.
	 *
	 * @param {HTMLElement} target - The clicked elelment.
	 * @returns {string} String representation of the clicked element.
	 */
	const getClickedElement = (target) => {
		if (target.classList.contains('v-button')) {
			return 'CTA';
		}

		if (target.classList.contains('v-video-trigger')) {
			return 'Video Trigger';
		}

		if (target.classList.contains('v-footer__newsletter-btn')) {
			return 'Newsletter';
		}

		let name = '';
		const element = target.tagName.toLowerCase();

		switch (element) {
			case 'a':
				name = 'Link';
				break;
			case 'button':
			case 'input':
				name = 'Button';
				break;
			default:
				name = 'Element';
				break;
		}

		return name;
	};

	/**
	 * Get the clicked location.
	 *
	 * @param {HTMLElement} target - The clicked elelment.
	 * @returns {string} String representation of the clicked location.
	 */
	const getClickedLocation = (target) => {
		const parent = target.closest('.v-header, .v-sticky-header, .v-footer, article, section');
		let location = '';

		if (parent.classList.contains('v-header')) {
			location = 'Nav';
		} else if (parent.classList.contains('v-sticky-header')) {
			location = 'Sticky Nav';
		} else if (parent.classList.contains('v-footer')) {
			location = 'Footer';
		} else {
			const parentHeading = parent.querySelector('h1, h2, h3, h4, h5, h6');
			location = parentHeading ? parentHeading.innerText : '';

			if (parent.tagName.toLowerCase() === 'section') {
				location = parent.closest('article') ? `${parent.closest('article').querySelector('h1, h2, h3, h4, h5, h6').innerText} - ${location}` : location;
			}
		}

		// if it is Our Team page, we need to get the team member name
		if (location === 'Our Team') {
			const index = [...parent.querySelectorAll('.v-button')].indexOf(target);
			location = `${location} - ${parent.querySelectorAll('h3')[index].innerText}`;
		}

		// return location to sentense case
		return location.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase());
	};

	/**
	 * Get the clicked text.
	 *
	 * @param {HTMLElement} target - The clicked elelment.
	 * @returns {string} String representation of the clicked text.
	 */
	const getClickedText = (target) => {
		const elemWithAlt = target.querySelector('[alt]');
		const text = target.getAttribute('aria-label') || target.innerText || elemWithAlt.getAttribute('alt') || '';

		return text.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase());
	};

	// Listen to all clicks
	document.addEventListener('click', (event) => {
		const target = event.target.closest('a, button, input[type="submit"], input[type="button"], input[type="reset"]');

		if (!target || target.closest('.v-cookie-banner')) {
			return;
		}

		dataLayer.push({
			event:          'v_click',
			click_element:  getClickedElement(target),
			click_location: getClickedLocation(target),
			click_text:     getClickedText(target),
		});
	});
};

export default vAnalytics;
